import { useEffect } from 'react';
import { useGetUserInfo } from '../hooks/http/use-get-user-info';
import { useAuth } from '../hooks/use-auth';
import { useUser } from '../hooks/use-user';

export function UserSync() {
  const { user } = useUser();
  const { isAuthenticated, token } = useAuth();

  const currentUser = user.get();

  const { mutate: getUserInfo } = useGetUserInfo({
    onSuccess: ({ data }) => {
      user.update({
        id: data.id,
        phone: data.phone,
        name: data.name,
        email: data.email,
        avatar: data.avatar || '',
      });
    },
  });

  useEffect(() => {
    // Só sincroniza se está autenticado e não tem dados do usuário
    if (isAuthenticated && !currentUser?.phone) {
      getUserInfo({ token: token.get()! });
    }
  }, [isAuthenticated, currentUser?.phone, getUserInfo, token]);

  return null;
}
